import * as backend from 'backend-helpers/memberPhotos';

const GET_MEMBER_PHOTOS_REQUEST = 'GET_MEMBER_PHOTOS_REQUEST';
const GET_MEMBER_PHOTOS_SUCCESS = 'GET_MEMBER_PHOTOS_SUCCESS';
const GET_MEMBER_PHOTOS_FAILURE = 'GET_MEMBER_PHOTOS_FAILURE';

import {
    MEMBER_PHOTO_UPLOADED,
    MEMBER_PHOTO_DELETED,
    MEMBER_PHOTO_SAVED
} from './member';

import {
    ALBUM_CERTIFIED,
    ALBUM_PUBLIC,
    ALBUM_XXL
} from '../constants/memberPhoto';

const initState = {
    [ALBUM_PUBLIC]: [],
    [ALBUM_XXL]: [],
    [ALBUM_CERTIFIED]: [],
};

export default function memberPhotos(state = initState, action) {
    if (action.type === GET_MEMBER_PHOTOS_SUCCESS) {
        let {status, ...rest} = action.result.data;

        return {
            ...rest
        }
    }

    if (action.type === MEMBER_PHOTO_UPLOADED) {
        if (state[action.memberPhoto.type]) {
            return {
                ...state,
                [action.memberPhoto.type]: [action.memberPhoto, ...state[action.memberPhoto.type]]
            }
        }
    }

    if (action.type === MEMBER_PHOTO_DELETED) {
        return {
            ...state,
            [ALBUM_PUBLIC]: state[ALBUM_PUBLIC] && state[ALBUM_PUBLIC].filter((memberPhoto) => memberPhoto.id !== action.id),
            [ALBUM_XXL]: state[ALBUM_XXL] && state[ALBUM_XXL].filter((memberPhoto) => memberPhoto.id !== action.id),
            [ALBUM_CERTIFIED]: state[ALBUM_CERTIFIED] && state[ALBUM_CERTIFIED].filter((memberPhoto) => memberPhoto.id !== action.id),
        }
    }

    if (action.type === MEMBER_PHOTO_SAVED) {
        if (state[action.memberPhoto.type]) {
            return {
                ...state,
                [action.memberPhoto.type]: state[action.memberPhoto.type].map((memberPhoto) => memberPhoto.id !== action.memberPhoto.id ? memberPhoto : action.memberPhoto),
            }
        }
    }

    return state;
}

export function getMemberPhotos() {
    return {
        types: [GET_MEMBER_PHOTOS_REQUEST, GET_MEMBER_PHOTOS_SUCCESS, GET_MEMBER_PHOTOS_FAILURE],
        promise: backend.getMemberPhotos()
    }
}




// WEBPACK FOOTER //
// ./src/reducers/memberPhotos.js